(() => {
  if (window.CaffreyMinklux) {
    window.CaffreyMinklux.init();
    return;
  }
  const roots = new WeakMap();
  const films = new WeakMap();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const initRoot = root => {
    if (roots.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const cleanups = [];
    roots.set(root, () => { controller.abort(); cleanups.forEach(fn => fn()); roots.delete(root); });
    root.dataset.mlReady = 'true';
    const galleryControls = root.querySelector('[data-ml-gallery-controls]');
    if (galleryControls) galleryControls.hidden = false;
    root.querySelectorAll('[data-ml-select]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-ml-photo]').forEach(photo => { photo.hidden = photo.dataset.mlPhoto !== button.dataset.mlSelect; });
        root.querySelectorAll('[data-ml-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }, { signal });
    });
    const buy = root.querySelector('.cf-ml-buy');
    const float = root.querySelector('[data-ml-float]');
    if (buy && float && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        float.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
      observer.observe(buy);
      cleanups.push(() => observer.disconnect());
    }
    const form = root.querySelector('[data-ml-form]');
    const labels = JSON.parse(root.querySelector('[data-ml-labels]').textContent);
    let pending = false;
    form?.addEventListener('submit', async event => {
      if (!form.checkValidity()) return;
      event.preventDefault();
      if (pending) return;
      pending = true;
      const button = form.querySelector('[data-ml-add]');
      const status = form.querySelector('[data-ml-cart-status]');
      const link = form.querySelector('[data-ml-cart-link]');
      const originalLabel = button.innerHTML;
      const body = new FormData(form);
      const cartSurface = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartSurface?.getSectionsToRender) {
        body.append('sections', cartSurface.getSectionsToRender().map(section => section.id));
        body.append('sections_url', window.location.pathname);
        cartSurface.setActiveElement(button);
      }
      button.disabled = true;
      button.textContent = labels.adding;
      form.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || labels.error);
        status.textContent = labels.added;
        link.hidden = false;
        if (cartSurface?.renderContents && result.sections && Object.values(result.sections).every(Boolean)) {
          cartSurface.renderContents(result);
        }
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then(res => res.json()).then(cart => {
          const bubble = document.querySelector('.cart-count-bubble');
          if (bubble) {
            const count = bubble.querySelector('[aria-hidden="true"]');
            if (count) count.textContent = String(cart.item_count);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        }).catch(() => {});
      } catch (error) {
        status.textContent = error.message || labels.error;
      } finally {
        button.innerHTML = originalLabel;
        button.disabled = false;
        form.removeAttribute('aria-busy');
        pending = false;
      }
    }, { signal });
  };
  const initFilm = wrapper => {
    if (films.has(wrapper)) return;
    const film = wrapper.querySelector('video');
    if (!film) return;
    const controller = new AbortController();
    const { signal } = controller;
    film.controls = false;
    film.muted = true;
    film.loop = false;
    let visible = false;
    let observer;
    const syncPlayback = () => {
      if (visible && !motion.matches && !document.hidden && !film.ended) {
        film.play().catch(() => {});
      } else {
        film.pause();
      }
    };
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .4;
        syncPlayback();
      }, { threshold: .4 });
      observer.observe(film);
    }
    motion.addEventListener('change', syncPlayback, { signal });
    document.addEventListener('visibilitychange', syncPlayback, { signal });
    films.set(wrapper, () => { controller.abort(); observer?.disconnect(); film.pause(); films.delete(wrapper); });
  };
  const init = (scope = document) => {
    if (scope.matches?.('[data-ml-root]')) initRoot(scope);
    scope.querySelectorAll('[data-ml-root]').forEach(initRoot);
    if (scope.matches?.('[data-ml-film-wrap]')) initFilm(scope);
    scope.querySelectorAll('[data-ml-film-wrap]').forEach(initFilm);
  };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ml-root]').forEach(root => roots.get(root)?.());
    event.target.querySelectorAll('[data-ml-film-wrap]').forEach(wrapper => films.get(wrapper)?.());
  });
  document.addEventListener('shopify:block:select', event => { const details = event.target.closest('details'); if (details) details.open = true; });
  window.CaffreyMinklux = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
